import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { ISlpService } from '@intigral/domain/lib/application/services/SlpService';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import user from '../../../helpers/user';
import { useConfiguration } from '../../../hooks/useConfiguration';
import { isGuestUser } from '../../../config/guestMode';

const fetchBundleAndSaveRules = async () => {
    try {
        const appKey = process.env.NX_PUBLIC_APP_KEY || '';
        const { operator, identityToken } = user.getUserInfo() || {};
        if (!user.isBundleAndSaveEnabled(operator)) {
            return;
        }
        const slpService = container.resolve<ISlpService>(DI.SERVICES.ISlpService);
        const data = await slpService.bundleAndSaveRules({ operator, appKey: appKey }, identityToken);
        if (data) {
            return data;
        }
    } catch (error) {
        throw error.message;
    }
};

export const bundleAndSaveRulesQueryOptions = {
    queryKey: ['bundle_and_save_rules'],
    queryFn: () => fetchBundleAndSaveRules(),
    // staleTime: 10 * 60 * 1000, // Consider data stale after 10 minutes
};

export const useBundleAndSaveRules = () => {
    const { operator } = user.getUserInfo() || {};
    const { data: configuration } = useConfiguration();
    const isEnabled = useMemo(() => user.isBundleAndSaveEnabled(operator), [configuration, operator]);

    return useQuery({
        ...bundleAndSaveRulesQueryOptions,
        enabled: isEnabled && !isGuestUser(user.getUserInfo()),
    });
};
